import { render, staticRenderFns } from "./pcbOnlySmt.vue?vue&type=template&id=463e3f82&scoped=true"
import script from "./pcbOnlySmt.vue?vue&type=script&lang=js"
export * from "./pcbOnlySmt.vue?vue&type=script&lang=js"
import style0 from "./pcbOnlySmt.vue?vue&type=style&index=0&id=463e3f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e3f82",
  null
  
)

export default component.exports